import React from 'react'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { v4 as uuid } from 'uuid'

import { scrollToDiv } from './Utils'

import { UIStore } from '../stores/UIStore'
import { observer } from 'mobx-react'
import { colors } from '../variables'

type MenuItemProps = {
  title: string
  link: string
  children?: [{ title: string; link: string }]
}

const getMenuItems = () => {
  const mnuItems: MenuItemProps[] = [
    { title: 'Jobba med oss', link: 'work' },
    { title: 'För utvecklare', link: 'developers' },
    { title: 'För kunder', link: 'customers' },
    { title: 'Referenser', link: 'references' },
    { title: 'Om oss', link: 'about' },
    { title: 'Kontakt', link: 'contact' },
  ]

  return mnuItems
}

const MenuItems = observer(() => {
  const location = useLocation()
  const menuitems = getMenuItems()
  const path = location.pathname.substring(1)

  return (
    <ul>
      {menuitems.map(page => {
        return (
          <React.Fragment key={uuid()}>
            <StyledLi
              key={uuid()}
              color={
                path === page.link
                  ? colors.orange
                  : UIStore.backgroundShade === colors.green
                  ? colors.white
                  : colors.green
              }
            >
              <Link to={`/${page.link}`}>{page.title}</Link>
            </StyledLi>
            {page.children &&
              page.children.map(page => (
                <MediaQuery maxDeviceWidth={768} key={uuid()}>
                  <StyledSubLi>
                    <button onClick={() => scrollToDiv(page.link)}>
                      {page.title}
                    </button>
                  </StyledSubLi>
                </MediaQuery>
              ))}
          </React.Fragment>
        )
      })}
    </ul>
  )
})

export const MobileMenuItems = () => {
  const menuitems = getMenuItems()

  return (
    <ul>
      {menuitems.map(page => {
        return (
          <React.Fragment key={uuid()}>
            <StyledLi key={uuid()} color={colors.white}>
              <Link
                to={`/${page.link}`}
                onClick={() => UIStore.toggleMobileMenu(false)}
                style={{ fontSize: 32 }}
              >
                {page.title}
              </Link>
            </StyledLi>
          </React.Fragment>
        )
      })}
    </ul>
  )
}

const StyledLi = styled.li`
  margin-right: 40px;
  white-space: nowrap;
  user-select: none;

  a {
    font-family: Gelion;
    font-size: 18px;
    color: ${({ color }: { color: string }) => color};
    letter-spacing: 0.8px;
    background: transparent;
    border: 0;
    cursor: pointer;
    outline: none;
  }

  &:last-child {
    margin-right: 0;
  }
`

const StyledSubLi = styled(StyledLi)`
  margin-left: 20px;
  margin-bottom: 8px;

  button {
    text-transform: none;
  }

  :first-child {
    margin-top: -10px;
  }
`

export default MenuItems
